import { render, staticRenderFns } from "./FeatureAreaComponent.vue?vue&type=template&id=9087303c&lang=pug&"
import script from "./FeatureAreaComponent.vue?vue&type=script&lang=js&"
export * from "./FeatureAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports